import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAccountVisibility from "./AbstractAccountVisibility.js";

/**
 * Setting to always show all account rows in a report.
 */
class ShowAccountsVisibility extends AbstractAccountVisibility {
	isVisible() {
		return true;
	}

	static getType() {
		return "all";
	}

	static getLabel() {
		return _("All");
	}
}

export default ShowAccountsVisibility;
